export default function Layout({ children }: { children: React.ReactNode }) {
  return <div className="bg-zinc-100 dark:bg-zinc-900">{children}</div>;
}
